import { styled } from "styled-components";

export const ReiviewText = styled.span`
  width: 100%;
  color: #373636;
  font-weight: 600;
  margin: 8px;
  margin-left: 10px;
`;
